var _excluded = ["appearance", "actions", "children", "onClose", "shouldHideIcon", "isShow", "className", "position", "shouldCloseOnClickOutside", "shouldUsePortal", "isDismissible"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useRef, useCallback, useEffect } from 'react';
import { AlertCloseButton } from './components/AlertCloseButton.js';
import { AlertFooter } from './components/AlertFooter.js';
import { AlertPortal } from './components/AlertPortal.js';
import { AlertContainer, AlertContentContainer, AlertMark, AlertContent } from './styled.js';
import { Appearance, Position, ICONS } from './utils.js';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';

var Alert = function Alert(_ref) {
  var _ref$appearance = _ref.appearance,
      appearance = _ref$appearance === void 0 ? Appearance.Primary : _ref$appearance,
      actions = _ref.actions,
      children = _ref.children,
      _ref$onClose = _ref.onClose,
      onClose = _ref$onClose === void 0 ? function () {} : _ref$onClose,
      _ref$shouldHideIcon = _ref.shouldHideIcon,
      shouldHideIcon = _ref$shouldHideIcon === void 0 ? false : _ref$shouldHideIcon,
      _ref$isShow = _ref.isShow,
      isShow = _ref$isShow === void 0 ? false : _ref$isShow,
      className = _ref.className,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? Position.Top : _ref$position,
      _ref$shouldCloseOnCli = _ref.shouldCloseOnClickOutside,
      shouldCloseOnClickOutside = _ref$shouldCloseOnCli === void 0 ? false : _ref$shouldCloseOnCli,
      _ref$shouldUsePortal = _ref.shouldUsePortal,
      shouldUsePortal = _ref$shouldUsePortal === void 0 ? false : _ref$shouldUsePortal,
      _ref$isDismissible = _ref.isDismissible,
      isDismissible = _ref$isDismissible === void 0 ? false : _ref$isDismissible,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var alertWrapperRef = useRef(null);
  var handleClickOutside = useCallback(function (event) {
    var current = alertWrapperRef.current;

    if (current && event.target instanceof HTMLElement && !current.contains(event.target)) {
      onClose();
    }
  }, [onClose]);
  useEffect(function () {
    if (shouldCloseOnClickOutside) {
      if (isShow) {
        document.addEventListener('mousedown', handleClickOutside, false);
      } else {
        document.removeEventListener('mousedown', handleClickOutside, false);
      }
    }

    return function () {
      document.removeEventListener('mousedown', handleClickOutside, false);
    };
  }, [isShow, shouldCloseOnClickOutside, handleClickOutside]);
  if (!isShow) return null;
  return jsx(AlertPortal, {
    position: position,
    shouldUsePortal: shouldUsePortal,
    children: jsxs(AlertContainer, _objectSpread(_objectSpread({}, restProps), {}, {
      appearance: appearance,
      className: className,
      isDismissible: isDismissible,
      ref: alertWrapperRef,
      children: [jsxs(AlertContentContainer, {
        shouldHideIcon: shouldHideIcon,
        children: [!shouldHideIcon && jsx(AlertMark, {
          appearance: appearance,
          icon: ICONS[appearance]
        }), jsx(AlertContent, {
          isDismissible: isDismissible,
          shouldHideIcon: shouldHideIcon,
          children: children
        }), isDismissible && jsx(AlertCloseButton, {
          onClick: onClose
        })]
      }), actions ? jsx(AlertFooter, {
        actions: actions
      }) : null]
    }))
  });
};

export { Alert };
